export default "__VITE_ASSET__QAVzFSuk__"